import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-6b.svg'

const data = {
  question:
    'When you experience peer pressure to try something unhealthy or dangerous like vaping, there are many different approaches you could take to respond. Select all of the choices that are effective ways to respond to peer pressure to use e-cigarettes/vape:',
  inputType: 'checkbox',
  options: [
    {
      label: 'You could directly refuse by saying, “No, thank you.”',
    },
    {
      label: 'You could inform the person about the health risks.',
    },
    {
      label:
        'You could yell at the person in front of others to never ask you about that again.',
    },
    {
      label:
        'You could think of a strategy to avoid situations where you feel pressured.',
    },
    {
      label:
        'You could talk to a counselor or other trusted adult about how best to respond.',
    },
  ],
}

const correctInput = {
  [data.question]: [
    data.options[0].label,
    data.options[1].label,
    data.options[3].label,
    data.options[4].label,
  ],
}

const feedback = {
  success: {
    title: 'That’s right!',
    body: 'There are lots of right ways to respond to peer pressure to vape.',
  },
  error: {
    title: 'Not Quite',
    body:
      "There are many good options when trying to find ways to refuse vaping, like saying 'no' or talking to a trusted adult. You will learn more about this in this module.",
  },
}

export default {
  title: 'Question 2',
  path: '/prepare/question-2',
  content: (
    <Fragment>
      <Intro title="Question 2" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question2.js